import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M7.358 19.358a8 8 0 0 0 8.465 1.833l.269-.1a2 2 0 0 0 .712-3.287l-1.39-1.39a2 2 0 0 0-2.828 0l-.672.672a2 2 0 0 1-2.828 0l-2.172-2.172a2 2 0 0 1 0-2.828l.672-.672a2 2 0 0 0 0-2.828l-1.39-1.39a2 2 0 0 0-3.286.712l-.101.269a8 8 0 0 0 1.834 8.465z"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M12.293 4.293a1 1 0 0 1 1.414 0L16 6.586l2.293-2.293a1 1 0 1 1 1.414 1.414L17.414 8l2.293 2.293a1 1 0 0 1-1.414 1.414L16 9.414l-2.293 2.293a1 1 0 0 1-1.414-1.414L14.586 8l-2.293-2.293a1 1 0 0 1 0-1.414",
      clipRule: "evenodd"
    }
  )
);
var SvgMissedOutboundFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var MissedOutboundFilled_default = SvgMissedOutboundFilled;

export { MissedOutboundFilled_default as default };
